import { render, staticRenderFns } from "./phone-header.vue?vue&type=template&id=922d8228&scoped=true"
import script from "./phone-header.vue?vue&type=script&lang=js"
export * from "./phone-header.vue?vue&type=script&lang=js"
import style0 from "./phone-header.vue?vue&type=style&index=0&id=922d8228&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922d8228",
  null
  
)

export default component.exports